import { Link, useRouterState } from '@tanstack/react-router'
import { useQuery } from '@tanstack/react-query'
import { Button, Card, CardBody, EmptyState, Icon } from '@akillidernek/ui'
import { api } from '../api'
import { useTenantSlug } from '../use-tenant'

/**
 * Menüde olup ekranı henüz yazılmamış modüller.
 *
 * Ham 404 yerine bu ekran gösteriliyor: menü sunucudaki katalogdan geliyor
 * (YES-122) ve katalog, API'si hazır ama arayüzü yazılmamış modülleri de
 * içeriyor. Kullanıcı bağlantıya tıkladığında "sayfa yok" değil, "bu modül
 * henüz açılmadı" görmeli.
 *
 * Menüdeki başlığı sunucudan okuyoruz; burada ikinci bir liste tutmak, iki
 * yerin sessizce ayrışması demekti.
 */
export function Yakinda() {
  const slug = useTenantSlug()
  const path = useRouterState({ select: (state) => state.location.pathname })

  const { data: menu } = useQuery({
    queryKey: ['navigation', slug],
    enabled: Boolean(slug),
    queryFn: async () => {
      const { data } = await api.GET('/api/v1/navigation')
      return data ?? []
    },
  })

  const oge = menu?.find((item) => item.to === path)

  // Menüde hiç olmayan bir adres: gerçekten yanlış bir bağlantı.
  if (menu && !oge) {
    return (
      <Card>
        <CardBody>
          <EmptyState
            icon={<Icon name="search" size={24} aria-hidden />}
            title="Sayfa bulunamadı"
            description={`${path} diye bir ekran yok.`}
            action={
              <Link to="/">
                <Button variant="secondary">Özete dön</Button>
              </Link>
            }
          />
        </CardBody>
      </Card>
    )
  }

  const kilitli = oge?.locked === true

  return (
    <div className="flex flex-col gap-4">
      <h1 className="text-lg font-semibold">{oge?.label ?? 'Modül'}</h1>
      <Card>
        <CardBody>
          <EmptyState
            icon={
              <Icon name={kilitli ? 'shield-alert' : 'layout-dashboard'} size={24} aria-hidden />
            }
            title={kilitli ? 'Bu modül planınızda yok' : 'Bu ekran henüz açılmadı'}
            description={
              kilitli
                ? 'Paketi eklediğinizde bu bölüm kullanılabilir hâle gelir.'
                : 'Modülün sunucu tarafı hazır; arayüzü sıradaki sürümlerde geliyor.'
            }
            action={
              <Link to="/">
                <Button variant="secondary">Özete dön</Button>
              </Link>
            }
          />
        </CardBody>
      </Card>
    </div>
  )
}
